import { render, staticRenderFns } from "./listIntegrations.vue?vue&type=template&id=6beda9e6&scoped=true"
import script from "./listIntegrations.vue?vue&type=script&lang=js"
export * from "./listIntegrations.vue?vue&type=script&lang=js"
import style0 from "./listIntegrations.vue?vue&type=style&index=0&id=6beda9e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beda9e6",
  null
  
)

export default component.exports